import { formatPhoneNumber } from 'utils/formatting'
import { TruncatedExternalLinkCell } from './TruncatedExternalLinkCell'

export const PhoneCell = ({
  phoneNumber,
  extension,
}: {
  phoneNumber?: string
  extension?: string
}) => {
  if (!phoneNumber) return '-'

  const formatted = formatPhoneNumber({ phoneNumber, extension })
  // External-link cell so a long number (with extension) truncates to one line
  // and shows the full value in a tooltip on hover.
  return (
    <TruncatedExternalLinkCell text={formatted} href={`tel:${formatted}`} />
  )
}
